export const visit = (vm, at) => {
vm(require("foundations-components/lang/fr-ca.lyaml"));
at({ "fr-ca": { "placeholder": "placeholder" } });
};